/* eslint-disable no-param-reassign */
import { RefObject } from 'react';

const handleScrollToTop = (elementReference?: RefObject<HTMLDivElement>) => {
    if (elementReference?.current) {
        elementReference.current.scrollTop = 0;
    }
};

export const makeHandleScrollToTop = (
    elementReference?: RefObject<HTMLDivElement>,
) => () => {
    handleScrollToTop(elementReference);
};

const handleScrollToAnchorTop = (
    wrapperReference?: RefObject<HTMLDivElement>,
    anchorReference?: RefObject<HTMLDivElement>,
): void => {
    if (wrapperReference && wrapperReference?.current && anchorReference && anchorReference?.current) {
        wrapperReference.current.scrollTop
        = anchorReference.current.getBoundingClientRect().top
        - wrapperReference.current.getBoundingClientRect().top
        + wrapperReference.current.scrollTop
        - 74;
    }
};

export const makeHandleScrollToAnchorTop = (
    wrapperReference?: RefObject<HTMLDivElement>,
) => (
    anchorReference?: RefObject<HTMLDivElement>,
) => {
    handleScrollToAnchorTop(wrapperReference, anchorReference);
};
